/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getRolesQueryExcludeOwnerDefault = false;

export const getRolesQueryParams = zod.object({
  "roleType": zod.enum(['Staff', 'Talent']).optional(),
  "excludeOwner": zod.boolean().optional()
})

export const getRolesResponseItem = zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "roleType": zod.enum(['Staff', 'Talent']),
  "permissions": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish()
})),
  "userCount": zod.number()
})
export const getRolesResponse = zod.array(getRolesResponseItem)

export const getRoleByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getRoleByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "permissions": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish()
})),
  "users": zod.array(zod.object({
  "id": zod.string().uuid(),
  "email": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "fullName": zod.string().nullish(),
  "isActive": zod.boolean(),
  "joinDate": zod.string().datetime({})
}))
})

export const addUsersToRoleParams = zod.object({
  "id": zod.string().uuid()
})

export const addUsersToRoleBody = zod.object({
  "userIds": zod.array(zod.string().uuid())
})

